import React from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "styled-components";
import { Card } from "storybook-components/Card";
import { ModulePrimaryBtn } from "storybook-components/Button";
import { H4, H5, Caption } from "storybook-components/Typography";

const StyledLink = styled.a`
  display: block;
  border-radius: 0;
  text-decoration: none !important;
  padding: 8px 0;
  width: 100%;
  cursor: pointer;
  ${({ theme }) => theme.media.tabletUp`
    padding: 8px;
    margin-bottom: 32px;
  `};
`;

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.green1};
  box-shadow: none;
  border-radius: 10px;
  &:hover {
    box-shadow: none;
  }
`;

const StyledCta = styled(H4)`
  text-align: center;
  color: ${({ theme }) => theme.colors.gray12};
  margin-top: 3rem;
  margin-bottom: 0;
`;

const StyledTitle = styled(H5)`
  color: ${({ theme }) => theme.colors.green5};
  margin-top: 0;
  margin-bottom: 12px;
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => theme.media.tabletUp`
    flex-direction: row;
  `};
`;

const CardImage = styled(GatsbyImage)`
  min-width: 260px;
  margin: auto;
  border-radius: 10px;
`;

const CopyWrapper = styled.div`
  width: 260px;
  margin: 16px auto 0;
  ${({ theme }) => theme.media.desktopUp`
    width: unset;
    margin: 0 0 0 32px;
  `};
`;

const BlogPostCardLink = ({ cta, url, imageData, title, description, buttonText }) => {
  const image = getImage(imageData);
  return (
    <>
      <StyledCta>{cta}</StyledCta>
      <StyledLink href={url} target="_blank">
        <StyledCard>
          <FlexContainer>
            <CardImage image={image} objectFit="contain" />
            <CopyWrapper>
              <StyledTitle>{title}</StyledTitle>
              <Caption>{description}</Caption>
              {buttonText && <ModulePrimaryBtn>{buttonText}</ModulePrimaryBtn>}
            </CopyWrapper>
          </FlexContainer>
        </StyledCard>
      </StyledLink>
    </>
  );
};

export default BlogPostCardLink;
